import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { AuthWrapperComponent } from '@shared/auth-wrapper/auth-wrapper.component';
import { IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, FormsModule, AuthWrapperComponent]
})
export class LoginComponent implements OnInit {
    isPasswordVisible: boolean;
    passwordVisibleIcon: SafeHtml;
    passwordNotVisibleIcon: SafeHtml;

    constructor(
        private readonly router: Router,
        private readonly authService: AuthService,
        private readonly iconSanitizer: IconSanitizerService
    ) {
        this.passwordVisibleIcon = this.iconSanitizer.getIcon('passwordVisible');
        this.passwordNotVisibleIcon = this.iconSanitizer.getIcon('passwordNotVisible');
        this.isPasswordVisible = false;
    }

    ngOnInit(): void {
        this.authService.redirectIfAuthenticated();
    }

    async login(form: NgForm): Promise<void> {
        if (form.invalid) {
            return;
        }

        await this.authService.login({
            email: form.value.email,
            password: form.value.password,
            rememberUser: form.value.rememberUser
        });
    }

    togglePasswordVisibility(event: Event): void {
        event.preventDefault();
        this.isPasswordVisible = !this.isPasswordVisible;
    }

    onForgotPassword(event: Event): void {
        event.preventDefault();
        this.router.navigate(['/forgot-password']);
    }
}
